export default function NotFoundPage() {
  return (
    <main className="system-page">
      <div className="system-page__inner">
        <p className="system-page__code">404</p>
        <h1>Page Not Found</h1>
        <p>The page you requested does not exist.</p>
        <a href="/">Return to home</a>
      </div>
    </main>
  );
}
